// extracted by mini-css-extract-plugin
export default {"reactPlayer":"Template8_reactPlayer__m5hzz","tagLine":"Template8_tagLine__Y-Bde","button":"Template8_button__fRCcr"};